import { phoneVariantSchema, phoneVariantsSchema } from "./schema";
import { getEntity, getEntityIds, getEntities } from "./base";
import { PRODUCT_TYPES } from "../constants/productTypes";

const path = "/portal/api/phone_variants";

const getPhoneVariant = (clientConfig, entityId) => {
  return getEntity(clientConfig, entityId, path, phoneVariantSchema);
};

const getPhoneVariantByEan = (clientConfig, ean) => {
  return getEntity(clientConfig, `find?ean=${ean}`, path);
};

const getPhoneVariantsByEans = (clientConfig, eans) => {
  let promises = [];

  for (const ean of eans) {
    promises.push(
      getPhoneVariantByEan(clientConfig, ean).catch((e) => {
        return undefined;
      })
    );
  }

  return Promise.all(promises);
};

const getPhoneVariantIds = (clientConfig, offerType, dataStatus) => {
  return getEntityIds(
    clientConfig,
    dataStatus,
    path,
    offerType,
    clientConfig.limits
  );
};

const getPhoneVariants = (clientConfig, dataStatus) => {
  let limits = { ...clientConfig.limits };
  limits.dataSpeedGen = [];
  limits.providerId = [];

  return getEntities(
    clientConfig,
    dataStatus,
    path,
    phoneVariantsSchema,
    { productType: PRODUCT_TYPES.phone },
    limits
  );
};

export {
  getPhoneVariant,
  getPhoneVariantByEan,
  getPhoneVariantIds,
  getPhoneVariants,
  getPhoneVariantsByEans
};
